(function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller( "CommentUnsavedDeleteDialogController", CommentUnsavedDeleteDialogController );

    CommentUnsavedDeleteDialogController.$inject = [ 'entity', '$uibModalInstance', 'MiscService' ];

    function CommentUnsavedDeleteDialogController( entity, $uibModalInstance, MiscService ) {

        var vm = this;

        vm.comment = entity;

        vm.close = close;
        vm.confirmDelete = confirmDelete;
        vm.nl2br = MiscService.nl2br;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            $uibModalInstance.close( true );
        }
    }
})();
